import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { TableCell, TableRow } from '@mui/material';
import { DragHandle } from '../../../icons/essentials/DragHandle';
export function SortableTableRow(param) {
    let { id, rowTestId, handleTestId, className, children } = param;
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id
    });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.6 : undefined,
        position: isDragging ? 'relative' : undefined,
        zIndex: isDragging ? 1 : undefined
    };
    return /*#__PURE__*/ _jsxs(TableRow, _object_spread_props(_object_spread({
        ref: setNodeRef,
        className: className,
        "data-testid": rowTestId,
        style: style
    }, attributes), {
        children: [
            /*#__PURE__*/ _jsx(TableCell, {
                padding: "checkbox",
                children: /*#__PURE__*/ _jsx("span", _object_spread_props(_object_spread({
                    "data-testid": handleTestId,
                    style: {
                        cursor: 'grab',
                        display: 'inline-flex'
                    }
                }, listeners), {
                    children: /*#__PURE__*/ _jsx(DragHandle, {
                        size: 16
                    })
                }))
            }),
            children
        ]
    }));
}
